"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const slider = document.querySelector(".o-galeria__slider.splide");

        if (!slider) return;

        const splide = new Splide(slider, {
            type: "loop",
            autoplay: true,
            perPage: 3,
            perMove: 1,
            gap: "16px",
            arrows: true,
            pagination: false,
            breakpoints: {
                768: {
                    perPage: 1,
                },
            },
        });
        const bar = splide.root.querySelector(".my-slider-progress-bar");
        splide.on("mounted move", function () {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min((splide.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + "%";
        });

        splide.mount();
    });
}
